/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    textButton: {
        ...theme.custom.elements.textButton.textButtonStyle
    }
}));

interface TextButtonProps {
    testId?: string,
    buttonLabel: string,
    onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined
}

function TextButton(props: TextButtonProps) {
    const classes = useStyles();

    const textButtonLabel = props.buttonLabel;
    const handleTextButtonClick = props.onClick;

    return (
        <Button
            data-testid={props.testId}
            className={classes.textButton}
            onClick={handleTextButtonClick}
        >
            {textButtonLabel}
        </Button>
    )
}

export default TextButton;
